module.exports = __webpack_public_path__ + "img/adobe-japan-prerelease-advisor-badge.613e9fb.png";